import React, { useState } from 'react';
import './MainSectionEditor.css';

interface MainSectionEditorProps {
  selectedSection: string | null;
  editMode: boolean;
  editableContent: { [key: string]: string };
  handleSectionClick: (section: string) => void;
  handleEditChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleMainImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSaveChanges: () => void;
  handleCancelEdit: () => void;
}

const MainSectionEditor: React.FC<MainSectionEditorProps> = ({
  selectedSection,
  editMode,
  editableContent,
  handleSectionClick,
  handleEditChange,
  handleMainImageChange,
  handleSaveChanges,
  handleCancelEdit,
}) => {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const toggleSection = (section: string) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="main-section-editor-accordion">
      <div className="accordion-item">
        <h3 onClick={() => toggleSection('main-section')}>Sección Principal</h3>
        {activeSection === 'main-section' && (
          <div className="accordion-content">
            {/* Título Principal */}
            <div className="main-item">
              <button
                onClick={() => handleSectionClick('main-title')}
                className={selectedSection === 'main-title' ? 'selected-menu-item' : ''}
              >
                Editar Título Principal
              </button>
              {editMode && selectedSection === 'main-title' && (
                <div className="editor-panel">
                  <h4>Editar Título Principal</h4>
                  <input
                    type="text"
                    name="main-title"
                    value={editableContent['main-title'] || ''}
                    onChange={handleEditChange}
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Párrafo Principal */}
            <div className="main-item">
              <button
                onClick={() => handleSectionClick('main-paragraph')}
                className={selectedSection === 'main-paragraph' ? 'selected-menu-item' : ''}
              >
                Editar Párrafo Principal
              </button>
              {editMode && selectedSection === 'main-paragraph' && (
                <div className="editor-panel">
                  <h4>Editar Párrafo Principal</h4>
                  <textarea
                    name="main-paragraph"
                    value={editableContent['main-paragraph'] || ''}
                    onChange={handleEditChange}
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Subpárrafo Principal */}
            <div className="main-item">
              <button
                onClick={() => handleSectionClick('main-subparagraph')}
                className={selectedSection === 'main-subparagraph' ? 'selected-menu-item' : ''}
              >
                Editar Subpárrafo Principal
              </button>
              {editMode && selectedSection === 'main-subparagraph' && (
                <div className="editor-panel">
                  <h4>Editar Subpárrafo Principal</h4>
                  <textarea
                    name="main-subparagraph"
                    value={editableContent['main-subparagraph'] || ''}
                    onChange={handleEditChange}
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>

            {/* Imagen Principal */}
            <div className="main-item">
              <button
                onClick={() => handleSectionClick('imagen')}
                className={selectedSection === 'imagen' ? 'selected-menu-item' : ''}
              >
                Cambiar Imagen Principal
              </button>
              {editMode && selectedSection === 'imagen' && (
                <div className="editor-panel">
                  <h4>Cambiar Imagen Principal</h4>
                  <input
                    type="file"
                    name="imagen"
                    onChange={handleMainImageChange}
                    accept="image/*"
                  />
                  <button onClick={handleSaveChanges}>Guardar Cambios</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainSectionEditor;
